import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PickupMonitorOrdersCards, PickupMonitorOrdersContent, PickupMonitorOrdersTitle, PickupMonitorOrdersTitleText, PickupMonitorOrdersTitleTextBlock, PickupMonitorOrdersWrap } from './index.styled'
import MainIcon from '../../../img/svg/main'
import PickupMonitorOrderCard from './card'
import { getAwaitingPickupOrdersThunk, getProcessingPickupOrdersThunk } from '../../../redux/thunk/pickupMonitor'
import { useDispatch, useSelector } from 'react-redux'
import { selectSortedAwaitingPickupOrders, selectSortedProcessingPickupOrders } from '../../../redux/selector/pickupMonitor'
import Tabs from '../../Elements/tabs'
import { useWindowBreakPoint } from '../../../hooks/useWindowBreakPoint'
import { theme } from '../../../style/theme'

const PickupMonitorOrders = React.memo(() => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [activeTab, setActiveTab] = useState('AWAITING_ORDERS')
	const toggled = useSelector(store => store.system.toggled)
	const awaitingPickupOrders = useSelector(selectSortedAwaitingPickupOrders)
	const processingPickupOrders = useSelector(selectSortedProcessingPickupOrders)
	const awaitingPickupOrdersTotal = awaitingPickupOrders.length
	const processingPickupOrdersTotal = processingPickupOrders.length
	const toggledLayout = toggled ? 'toggled' : ''
	const isTablet = useWindowBreakPoint(theme.point820)

	useEffect(() => {
		dispatch(getAwaitingPickupOrdersThunk())
		dispatch(getProcessingPickupOrdersThunk())
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const ordersTabs = useMemo(() => [
		{ value: 'AWAITING_ORDERS', title: `${t('PickupMonitor.awaiting')}: ${awaitingPickupOrdersTotal}` },
		{ value: 'PICKUP_ORDERS', title: `${t('PickupMonitor.processing')}: ${processingPickupOrdersTotal}` }
	], [t, awaitingPickupOrdersTotal, processingPickupOrdersTotal])

	const handleTabClick = useCallback((tab) => {
		setActiveTab(tab)
	}, [])

	return (
		<>
			<PickupMonitorOrdersWrap className={toggledLayout}>
				{isTablet && <Tabs tabs={ordersTabs} onTabClick={handleTabClick} activeTab={activeTab} />}
				{(!isTablet || activeTab === 'AWAITING_ORDERS') &&
					<PickupMonitorOrdersContent>
						{!isTablet && <PickupMonitorOrdersTitle>
							<MainIcon icon="clock" />
							<PickupMonitorOrdersTitleTextBlock>
								<PickupMonitorOrdersTitleText>{t('PickupMonitor.awaiting')}:</PickupMonitorOrdersTitleText>
								<PickupMonitorOrdersTitleText>{awaitingPickupOrdersTotal}</PickupMonitorOrdersTitleText>
							</PickupMonitorOrdersTitleTextBlock>
						</PickupMonitorOrdersTitle>}
						<PickupMonitorOrdersCards className={toggledLayout + '-awaiting-pickup'}>
							{awaitingPickupOrders.map((order, i) =>
								<PickupMonitorOrderCard key={order.orderId}
																				order={order}
																				index={i} />)}
						</PickupMonitorOrdersCards>
					</PickupMonitorOrdersContent>}

				{(!isTablet || activeTab === 'PICKUP_ORDERS') &&
					<PickupMonitorOrdersContent className="processing-pickup">
						{!isTablet && <PickupMonitorOrdersTitle>
							<MainIcon icon="clipboard" />
							<PickupMonitorOrdersTitleTextBlock>
								<PickupMonitorOrdersTitleText>{t('PickupMonitor.processing')}:</PickupMonitorOrdersTitleText>
								<PickupMonitorOrdersTitleText>{processingPickupOrdersTotal}</PickupMonitorOrdersTitleText>
							</PickupMonitorOrdersTitleTextBlock>
						</PickupMonitorOrdersTitle>}

						<PickupMonitorOrdersCards className={toggledLayout}>
							{processingPickupOrders.map((order, i) =>
								<PickupMonitorOrderCard key={order.orderId}
																				order={order}
																				index={i} />)}
						</PickupMonitorOrdersCards>
					</PickupMonitorOrdersContent>}
			</PickupMonitorOrdersWrap>
		</>
	)
})

PickupMonitorOrders.displayName = 'PickupMonitorOrders'
export default PickupMonitorOrders
